import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { getCallableMessage, unwrapCallableData } from './callableResponse';

interface ShopifyProductGenerationRequest {
    id: string,
    shopId: string
}

interface ShopifyProductGenerationResponse {
    id: string;
}

const shopifyProductGeneration = async (shopId: string, id: string): Promise<ShopifyProductGenerationResponse> => {
    const shopifyProductGeneration = httpsCallable<ShopifyProductGenerationRequest, ShopifyProductGenerationResponse>(functions, 'handle_shopify_product_generation');
    const result = await shopifyProductGeneration({ shopId, id });
    return result.data;
};


interface ScheduleShopifyProductGenerationTasksRequest {
    id: string,
}

interface scheduleShopifyProductGenerationTaskResponse {
    id?: string;
    scheduledCount: number;
    quotaReached: boolean;
    jobCreated?: boolean;
    message?: string;
}

const scheduleShopifyProductGenerationTask = async (id: string): Promise<scheduleShopifyProductGenerationTaskResponse> => {
    const scheduleShopifyProductGenerationTask = httpsCallable<ScheduleShopifyProductGenerationTasksRequest, scheduleShopifyProductGenerationTaskResponse>(functions, 'handle_schedule_shopify_product_generation_tasks');
    const result = await scheduleShopifyProductGenerationTask({ id });
    return {
        ...unwrapCallableData<scheduleShopifyProductGenerationTaskResponse>(result.data),
        message: getCallableMessage(result.data),
    };
};





export { shopifyProductGeneration, scheduleShopifyProductGenerationTask };
